import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

interface FoodSearchData {
  keyword: string
  type: React.Key
  searched: boolean
}

interface FoodSearchAction {
  setKeyword: (keyword: string) => void
  setType: (type: React.Key) => void
  setSearched: (searched: boolean) => void
  reset: () => void
}

type FoodSearchState = FoodSearchData & FoodSearchAction

const initialState: FoodSearchData = {
  keyword: "",
  type: "all",
  searched: false,
}

const useFoodSearchDataStore = create(
  immer<FoodSearchState>((set) => ({
    ...initialState,
    setKeyword: (keyword) => {
      set((state) => {
        state.keyword = keyword
      })
    },
    setSearched: (searched) => {
      set((state) => {
        state.searched = searched
      })
    },
    setType: (type) => {
      set((state) => {
        state.type = type
      })
    },
    reset: () => {
      set(initialState)
    },
  }))
)

export type { FoodSearchData, FoodSearchAction }
export { useFoodSearchDataStore }
